<template>
    <div class="rs-index-container">
        <router-view v-slot="{ Component }">
            <keep-alive>
                <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.path"></component>
            </keep-alive>
            <component :is="Component" v-if="!$route.meta.keepAlive"></component>
        </router-view>
    </div>
</template>

<script>
export default {
    // "光明小记者嘉年华"
    name: "carnivalIndex",
    data() {
        return {}
    },
}
</script>

<style lang="less" scoped>
.banner {
    width: 100%;
}
.rs-index-container {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    padding-bottom: var(--van-tabbar-height);
    background-color: #56b0fe;
}
@supports (-webkit-touch-callout: none) {
    .rs-index-container {
        margin-bottom: 40px;
    }
}
.text-transparent {
    font-weight: bold;
}

.van-tabbar {
    background-color: #fff;
}

@supports (-webkit-touch-callout: none) {
    .bg-current {
        padding-bottom: 40px;
    }
}
.van-tabbar-item--active {
    background-color: #56b0fe;
}
</style>
